import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CfCoreComponent } from '../core/core.component';
import { TemplateService } from '../../services/template-service/template.service';
/**
 * <p>CfJsonEditorHeader component is used to display top content section</p>
 * <pre>
 * <code>
 * <code><</code>cf-json-editor-header<code>></code><code><</code><code>/</code>cf-json-editor-header<code>></code>
 * </code>
 * </pre>
 */
export class CfJsonEditorHeaderComponent extends CfCoreComponent implements OnInit {
   jsonEditorHeader;
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 */
constructor(public elementRef: ElementRef, /**@hidden */ templateService: TemplateService) { super(elementRef, templateService); }
/**
 * @hidden
 * @return {?}
 */
ngOnInit() {
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-json-editor-header',
  template: "<ng-container #jsonEditorHeader><ng-content></ng-content></ng-container>",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'jsonEditorHeader': [{ type: ViewChild, args: ['jsonEditorHeader', ] },],
};
}

function CfJsonEditorHeaderComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfJsonEditorHeaderComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfJsonEditorHeaderComponent.ctorParameters;
/** @type {?} */
CfJsonEditorHeaderComponent.propDecorators;
/** @type {?} */
CfJsonEditorHeaderComponent.prototype.jsonEditorHeader;
/** @type {?} */
CfJsonEditorHeaderComponent.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
